export const SALESFORCE_ORDER_URL: string = 'account/{accountId}/salesforce-order/{orderId}';

export const SALESFORCE_ORDER_FORM_DATA_URL: string = 'salesforce/accounts/{accountId}/lookup';

// Search Salesforce Accounts for the Corporate Related lookup (searchTerm passed as a query param).
export const SALESFORCE_ACCOUNT_SEARCH_URL: string = 'account/{accountId}/salesforce/account-search';

export const SALESFORCE_OPPORTUNITY_SEARCH_URL: string = 'account/{accountId}/salesforce/opportunity-search';

export const SALESFORCE_RECENT_ORDER_SEARCH_URL: string = 'account/{accountId}/salesforce/search';

export const SALESFORCE_PRICE_BOOK_PRODUCTS_URL: string = 'salesforce/pricebooks/{priceBookId}/products';

export const SALESFORCE_ORDER_CREATE_URL: string = 'account/{accountId}/event/{eventId}/salesforce-order';

export const SALESFORCE_ORDER_LINK_URL: string = 'account/{accountId}/event/{eventId}/salesforce-order/link';
